import { createSlice } from '@reduxjs/toolkit';
import { configFormsTexts } from 'locale/es';
import FormsService from 'services/FormsService';
import { toast } from './notificationReducer';

const initialState = { data: [], loading: false, error: null };

const formByPatientSlice = createSlice({
  name: 'formsByPatient',
  initialState,
  reducers: {
    setForms(state, action) {
      const { data } = action.payload;
      return { ...state, data, loading: false, error: null };
    },
    setFormsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setFormsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetFormsByPatient(state, action) {
      return initialState;
    },
  },
});

export const { setForms, setFormsLoading, setFormsError, resetFormsByPatient } =
  formByPatientSlice.actions;

export const initializeFormsByPatient = (patientId) => {
  return async (dispatch) => {
    try {
      dispatch(setFormsLoading());

      const { data } = await FormsService.getAllByPatient(patientId);
      dispatch(setForms({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setFormsError({
          message: error.message,
          status: error.response?.status,
        })
      );
      dispatch(toast(configFormsTexts.LOADING_ERROR, 'error'));
    }
  };
};

export default formByPatientSlice.reducer;
